import Details from '@/components/Details';
import DynamicChart from '@/pages/Reports/DynamicReport/components/DynamicChart';
import { Middle } from '@/components/Align';
import { ReportDisplayEnum } from '@/pages/Reports/DynamicReport';
import ReportTable from '@/pages/Reports/DynamicReport/components/ReportDisplay/ReportTable';
import { useMemo } from 'react';

const ReportDisplay = ({
  header,
  footer,
  tables,
  filters,
  details,
  onDetails,
  onEmpty,
  type,
  loading,
  as,
}: {
  header?: Record<string, unknown>;
  footer?: Record<string, unknown>;
  tables: any[];
  filters: Record<string, unknown>;
  details?: Record<string, unknown>;
  onDetails?: (detailsObj: Record<string, unknown>) => void;
  onEmpty?: JSX.Element;
  type?: string;
  loading?: boolean;
  as?: ReportDisplayEnum;
}): JSX.Element => {
  const RenderDataSet = useMemo((): React.ComponentType<any> => {
    switch (as) {
      case ReportDisplayEnum.CHART:
        return DynamicChart;
      case ReportDisplayEnum.TABLE:
      default:
        return ReportTable;
    }
  }, [as]);
  return (
    <>
      {header && <Details reportType={type} data={Object.entries(header).map(([key, value]: any): any => ({ [key]: value }))} />}
      {!!tables.length &&
        tables.map((table: any, t: number): JSX.Element => {
          const reportFilters = Object.entries(filters).reduce(
            (acc: Record<string, unknown>, [key, { value = null }]: any): Record<string, unknown> => {
              if (!key.startsWith('__')) acc[key] = !key.endsWith('s') ? value?.[0] || null : value;
              return acc;
            },
            {}
          );
          const tableFilters =
            table?.details?.reduce?.(
              (acc: Record<string, unknown>, { filters = [] }: { filters: Record<string, unknown>[] }): Record<string, unknown> =>
                filters?.reduce?.((accInner: Record<string, unknown>, filter: Record<string, unknown>): Record<string, unknown> => {
                  Object.entries(filter || {}).forEach(([key, value]: any): void => {
                    if (!key.startsWith('__')) accInner[key] = value;
                  });
                  return accInner;
                }, acc) || acc,
              {}
            ) || {};
          return (
            <RenderDataSet
              name={`${type}Table`}
              reportType={type}
              header={table?.metadata?.header ? table?.metadata?.header : undefined}
              footer={table?.metadata?.footer ? table?.metadata?.footer : undefined}
              columns={table?.metadata?.columns}
              rows={table?.children || []}
              index={t}
              key={t}
              details={details}
              filters={{ ...reportFilters, ...tableFilters }}
              onDetails={onDetails}
            />
          );
        })}
      {!loading && !tables.length && onEmpty && <Middle.Center className="py-5">{onEmpty}</Middle.Center>}
      {footer && <Details data={Object.entries(footer).map(([key, value]: any): any => ({ [key]: value }))} />}
    </>
  );
};

export default ReportDisplay;
